import { render } from "./SidebarView.vue?vue&type=template&id=0b4031fc&scoped=true"
import script from "./SidebarView.vue?vue&type=script&lang=js"
export * from "./SidebarView.vue?vue&type=script&lang=js"

import "./SidebarView.vue?vue&type=style&index=0&id=0b4031fc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b4031fc"]])

export default __exports__